import React from 'react';
import { AdvisoryBand } from '../components/AdvisoryBand';
import { PageHeader } from '../components/PageHeader';
export function Advisory() {
  return <>
      <PageHeader eyebrow="Advisory & Strategy" title="Counsel where business, government and public trust intersect." intro="Board directorship, strategic advisory and keynote engagements delivered through Blue-Water Strategies, LLC." data-id="element-279" data-mp="21pmba88cu50k" />
      <AdvisoryBand data-id="element-280" data-mp="2gkk5z7qz76kt" />
    </>;
}